<template>
  <b-modal
    id="modal"
    ref="modal"
    size="sm"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-container fluid class="p-a-0">
        <b-row>
          <b-col class="p-l-0">
            <label>Tipo da Liberação</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.tp_liberacao"
                :options="tp_liberacao_options"
                name="tp_liberacao"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('vlr')"
              v-if="form.errors.has('vlr')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import moment from "moment";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      id: "",
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      doctransp_id: [],
      isFullscreen: false,
      tp_liberacao_options: [
        { text: "Documento Transportadora", value: 2 },
        { text: "Rejeitar", value: 3 },
      ],
      errors_array: [],
      helpForm: new Form({
        statusRecord: [],
        params: [],
      }),
      form: new Form({
        tp_liberacao: "",
        doctransp_id: [],
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        // this.onUpdate(this.form.peduncatr_id);
      }
    },
    onCreate(data) {
      this.form.doctransp_id = [];
      this.doctransp_id = [];
      this.doctransp_id = data;
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Verificar";
      this.modal_botao = "Enviar";
      this.modal_acao = "i";
      this.form.reset();
      // this.form.doctransp_id = data;
      this.$refs.modal.show();
    },
    onEdit(data, index) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar Conta";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.$refs.modal.show();
    },
    onStore() {
      this.form.doctransp_id = this.doctransp_id;
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/auditoria/liberar")
        .then((response) => {
          new ReturnApi(response, this);
          this.$parent.$refs.vuetable.selectedTo = [];
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/conta/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
